<template>
  <div class="product-template __donate __limited-edu">

    <h1 data-v-1f20e9ef="" class="text-center mb-20">
      <img src="/static/img/limited-edu/logo-lmt-01.png" alt="Limited Education" width="260px"
           class="pd-15 ma-auto d-block"/>
    </h1>

    <div class="container pd-sm-0">
      <div class="col-md-push-2 col-md-10 col-lg-push-2 col-md-8">
        <h2 style="width: 100%; color: white; text-align: center">ยาดมไหมืนกะชุดนิทานอึนใจ</h2>
        <div class="product product--inline">
          <div class="product__block--form ">
            <div class="radius block shadow ">
              <product-donate-choice
                :show-donate-type="true"
                :product="product"
                v-model="product.price"
                ref="donateChoice"
                classes="col-1-5"/>

              <div class="mt-15 mb-15">
                <div style="background-color: #ccc;">
                  คงเเหลือ {{remainingBalance}}
                  จำนวนของ {{totalRewardItems}}
                </div>
              </div>

              <div class="form__wrapper mt-15 mb-15">
                <div class="form__section">
                  <label class="form__radio-lg">
                    ไม่ต้องการรับของ
                    <input class="" type="radio" name="optionsRadios" value="" v-model="attributes.info.rewardProduct"/>
                    <span class="checkmark"></span>
                  </label>
                </div><!-- end form section -->

                <div class="form__section">
                  <label class="form__radio-lg" :class="{disable: isRewardDisabled}">
                    รับยาดมไหมืนกะชุดนิทานอึนใจ <small>699 บาท</small>
                    <input class="" type="radio" name="optionsRadios" value="ยาดมไหมืนกะชุดนิทานอึนใจ"
                           :disabled="isRewardDisabled" v-model="attributes.info.rewardProduct"/>
                    <span class="checkmark"></span>
                  </label>
                </div><!-- end form section -->

                <transition name="slide-down">
                  <div class="slide-down-wrapper" :class="{disable: product.price < 699}"
                       v-show="attributes.info.rewardProduct === 'ยาดมไหมืนกะชุดนิทานอึนใจ'">
                    <div class="form__section block-third slide-down-item">
                      <div class="form__item--lmt-deu">
                        <div class="col-12 col-md-9">
                          <div class="active-image"
                               @click.prevent="showImage(itemImages[0][activeImages[0]].large)">
                            <img :src="itemImages[0][activeImages[0]].thumb" alt="Limited Education" width="90%"
                                 class="ma-auto d-block pd-15"/>
                          </div>

                          <div class="thumbnails d-flex" v-for="(item, idx) in itemImages[0]" :key="idx">
                            <div class="img-thumbnail" :class="idx === activeImages[0] ? 'active' : ''" @click="$set(activeImages, 0, idx)">
                              <img :src="item.thumb" alt=""/>
                            </div>
                          </div>
                        </div>

                        <div class="col-12 col-md-3">
                          <div>เลือกจำนวน</div>
                          <div class="d-flex">
                            <div class="btn btn--inline btn--sm" @click="dec(itemCounts, 0)">-</div>
                            <div class="ma-10">{{itemCounts[0]}}</div>
                            <div class="btn btn--inline btn--sm" @click="inc(itemCounts, 0)">+</div>
                          </div>
                        </div>
                      </div>
                    </div> <!-- end form_section -->
                  </div>
                </transition>


              </div><!-- end form wrapper -->

              <donor-info v-model="attributes.info.name"
                          class="pt-15"/>

              <page-selector
                :product="product"
                v-model="attributes.page"
                v-show="false"/>

              <product-cart-action
                :product="product"
                :attributes="attributes"
                :initialQuantity="1"
                :addToCartButton="false"
                :buyNowButton="false"
                :style="{margin:0}"
                ref="cartAction"/>

              <div class="text-center">
                <button type="button" class="btn btn--purple btn--default" @click.prevent="donate">บริจาค</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DonorInfo from '@/components/DonorInfo'
import PageSelector from '@/components/PageSelector'
import ProductCartAction from '@/components/ProductCartAction'
import ProductDonateChoice from '@/components/ProductDonateChoice'

export default {
  name: 'ProductTemplateLimitedEducation1',

  components: {
    DonorInfo,
    PageSelector,
    ProductCartAction,
    ProductDonateChoice
  },

  props: {
    title: {type: String, default: 'บริจาค'},
    product: {type: Object, required: true}
  },

  data () {
    return {
      attributes: {
        info: {
          name: '',
          rewardProduct: '',
          rewardConfigText: '',
          rewardConfigSize: '',
          rewardConfigChoice: ''
        },
        page: ''
      },
      isRewardDisabled: false,
      error: {
        rewardConfigText: false,
        rewardConfigSize: false
      },
      itemCounts: [0],
      itemImages: [
        [
          {thumb: '/static/img/limited-edu/lmt-product-ad-01.jpg', large: '/static/img/limited-edu/shirt1_ad.png'},
          {thumb: '/static/img/limited-edu/lmt-product-ad-02.jpg', large: '/static/img/limited-edu/shirt2_ad.png'},
          {thumb: '/static/img/limited-edu/lmt-product-ad-03.jpg', large: '/static/img/limited-edu/shirt3_ad.png'}
        ]
      ],
      activeImages: [0]
    }
  },

  created () {
    this.checkReward(this.product.price)
  },

  computed: {
    remainingBalance () {
      return this.product.price - (this.totalRewardItems * 699)
    },
    maxRewardItems () {
      return Math.floor(this.product.price / 699)
    },
    totalRewardItems () {
      return this.itemCounts.reduce((a, b) => a + b, 0)
    }
  },

  methods: {
    validate () {
      this.error.rewardConfigText = false
      this.error.rewardConfigSize = false

      let valid = true
      const {info} = this.attributes
      if (info.rewardProduct === null) {
        this.error.rewardProduct = true
        valid = false
      }
      return valid
    },
    donate () {
      if (!this.$refs.donateChoice.validate()) {
        return
      }

      if (!this.validate()) {
        return
      }

      this.$store.dispatch('clearCart').then(() => {
        this.$refs.cartAction.buyNow()
      })
    },
    checkReward (amount) {
      if (amount >= 699) {
        this.attributes.info.rewardProduct = 'ยาดมไหมืนกะชุดนิทานอึนใจ'
        this.attributes.info.rewardConfigText = ''
        this.attributes.info.rewardConfigSize = ''
        this.totalRewardItems = 1
        this.$set(this.itemCounts, 0, 1)
        this.isRewardDisabled = false
      } else {
        this.attributes.info.rewardProduct = ''
        this.attributes.info.rewardConfigText = ''
        this.attributes.info.rewardConfigSize = ''
        this.totalRewardItems = 0
        this.$set(this.itemCounts, 0, 0)
        this.isRewardDisabled = true
      }
    },
    showImage (src) {
      this.$modal.show({
        text: `<img class="img-enlarged" src="${src}" />`,
        okButtonText: 'ปิด'
      })
    },
    dec (items, idx) {
      this.$set(items, idx, Math.max(1, items[idx] - 1))
    },
    inc (items, idx) {
      this.$set(items, idx, Math.min(this.maxRewardItems, items[idx] + 1))
    }
  },

  watch: {
    'product.price': function (amount) {
      this.checkReward(amount)
    },
    'attributes.info.rewardConfigChoice': function (v, p) {
      if (v) {
        // this.attributes.info.rewardProduct = 'merchandise'
      }
    },
    'attributes.info.rewardProduct': function (v, p) {
      if (v !== p && (v !== 'merchandise' && v !== 'ad-addict')) {
        this.attributes.info.rewardConfigChoice = ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
h1.page-title {
  color: #fff;
  text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.5);
  font-size: 2em;
  font-weight: 400;
  margin-bottom: 15px;
}

h3.page-title {
  color: #fff;
  text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.5);
}

.block {
  background: #fff;
}

.btn--default {
  margin: 20px auto 10px;
}

.btn--sm {
  min-width: auto;
  width: 60px;
}

</style>



// WEBPACK FOOTER //
// limited-education-2021-group1.vue?c33fe25a